import React from 'react';
import { ShimmerComponent } from '@zydalabs/storefront-components';

type LazyLoadingTabsProps = {
  tabsNumber: number;
};
const LazyLoadingTabs: React.FC<LazyLoadingTabsProps> = ({ tabsNumber = 2 }): any => {
  const lazyLoading = (index: number) => (
    <ShimmerComponent.ShimmerEffect key={index}>
      <ShimmerComponent.NoAnimationBox mx={1} key={index}>
        <ShimmerComponent.Rect width={100} height={35} borderRadius={4} />
      </ShimmerComponent.NoAnimationBox>
    </ShimmerComponent.ShimmerEffect>
  );

  const loadingTabs: Array<React.ReactNode> = [];
  for (let counter = 0; counter < tabsNumber; counter += 1) {
    loadingTabs.push(lazyLoading(counter));
  }
  return loadingTabs;
};

export default LazyLoadingTabs;
